"use strict";
// (C) 2007-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCREEN_BREAKPOINT_XXL = exports.SCREEN_BREAKPOINT_XL = exports.SCREEN_BREAKPOINT_LG = exports.SCREEN_BREAKPOINT_MD = exports.SCREEN_BREAKPOINT_SM = exports.SCREEN_BREAKPOINT_XS = void 0;
// Default breakpoints
exports.SCREEN_BREAKPOINT_XS = 320;
exports.SCREEN_BREAKPOINT_SM = 640;
exports.SCREEN_BREAKPOINT_MD = 940;
exports.SCREEN_BREAKPOINT_LG = 1170;
exports.SCREEN_BREAKPOINT_XL = 1590;
exports.SCREEN_BREAKPOINT_XXL = 99999999;
//# sourceMappingURL=breakpoints.js.map